import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
//import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
//import * as $ from 'jquery';

//declare var carousel: any;
declare let refreshCarousel: any;


@Component({
  selector: 'app-commercial-services',
  templateUrl: './commercial-services.component.html'
})
export class CommercialServicesComponent implements OnInit, AfterViewInit {

  

  constructor() { }

  ngOnInit() {
    setTimeout(function () {
      try {
        console.clear();
        console.log("carousel start");
        refreshCarousel();
      } catch (e) {
        console.log(e.message);
      }

    }, 2000);
  }

  ngAfterViewInit() {
    
  }

}
